import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "time-picker";
var attributes = {
    TOGGLE: 'tcw-time-picker-toggle',
    VALUE: 'value',
    OPEN: 'open',
    ALLOW_SECONDS: 'allow-seconds',
    MASKED: 'masked',
    SHOW_MASK_FORMAT: 'show-mask-format',
    USE_CHAR_MASK: 'use-char-mask',
    USE_24_HOUR_TIME: 'use-24-hour-time',
    ALLOW_INVALID_TIME: 'allow-invalid-time',
    MIN: 'min',
    MAX: 'max',
    START_TIME: 'start-time',
    STEP: 'step',
    ALLOW_INPUT: 'allow-input',
    SHOW_NOW: 'show-now',
    DISABLED: 'disabled',
    POPUP_CLASSES: 'popup-classes',
    DIALOG_WIDTH_THRESHOLD: 'dialog-width-threshold',
    ALLOW_DROPDOWN: 'allow-dropdown'
};
var selectors = {
    INPUT: 'input, input[tcw-time-picker-input]',
    TOGGLE: "[" + attributes.TOGGLE + "]"
};
var events = {
    OPEN: elementName + "-open",
    CLOSE: elementName + "-close",
    INPUT: elementName + "-input",
    CHANGE: elementName + "-change"
};
var numbers = {
    DEFAULT_MINUTE_STEP: 60,
    MAX_DAY_MILLIS: 86400000,
    MAX_DAY_MINUTES: 1440
};
export var TIME_PICKER_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    selectors: selectors,
    events: events,
    numbers: numbers
};
